import { render } from "./Slope.vue?vue&type=template&id=1fbfd4cb&scoped=true"
import script from "./Slope.vue?vue&type=script&lang=js"
export * from "./Slope.vue?vue&type=script&lang=js"

import "./Slope.vue?vue&type=style&index=0&id=1fbfd4cb&scoped=true&lang=css"
import "./Slope.vue?vue&type=style&index=1&id=1fbfd4cb&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbfd4cb"]])

export default __exports__